import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-refresh" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type === '2')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "verify-img-out",
          style: _normalizeStyle({height: `${parseInt(_ctx.setSize.imgHeight) + _ctx.vSpace}px`})
        }, [
          _createElementVNode("div", {
            class: "verify-img-panel",
            style: _normalizeStyle({width: _ctx.setSize.imgWidth, height: _ctx.setSize.imgHeight,})
          }, [
            _createElementVNode("img", {
              src: _ctx.backImgBase,
              alt: "",
              style: {"width":"100%","height":"100%","display":"block"}
            }, null, 8, _hoisted_2),
            _withDirectives(_createElementVNode("div", {
              class: "verify-refresh",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
            }, _hoisted_4, 512), [
              [_vShow, _ctx.showRefresh]
            ]),
            _createVNode(_Transition, { name: "tips" }, {
              default: _withCtx(() => [
                (_ctx.tipWords)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["verify-tips", _ctx.passFlag ?'suc-bg':'err-bg'])
                    }, _toDisplayString(_ctx.tipWords), 3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 4)
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "verify-bar-area",
      style: _normalizeStyle({width: _ctx.setSize.imgWidth, height: _ctx.barSize.height, lineHeight: _ctx.barSize.height})
    }, [
      _createElementVNode("span", {
        class: "verify-msg",
        textContent: _toDisplayString(_ctx.text)
      }, null, 8, _hoisted_5),
      _createElementVNode("div", {
        class: "verify-left-bar",
        style: _normalizeStyle({width: (_ctx.leftBarWidth !== undefined) ? _ctx.leftBarWidth : _ctx.barSize.height, height: _ctx.barSize.height, borderColor: _ctx.leftBarBorderColor, transaction: _ctx.transitionWidth})
      }, [
        _createElementVNode("span", {
          class: "verify-msg",
          textContent: _toDisplayString(_ctx.finishText)
        }, null, 8, _hoisted_6),
        _createElementVNode("div", {
          class: "verify-move-block",
          style: _normalizeStyle({width: _ctx.barSize.height, height: _ctx.barSize.height, 'background-color': _ctx.moveBlockBackgroundColor, left: _ctx.moveBlockLeft, transition: _ctx.transitionLeft}),
          onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args))),
          onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(['verify-icon iconfont', _ctx.iconClass]),
            style: _normalizeStyle({color: _ctx.iconColor})
          }, null, 6),
          (_ctx.type === '2')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "verify-sub-block",
                style: _normalizeStyle({ 'width': Math.floor(parseInt(_ctx.setSize.imgWidth)* 47 / 310)+ 'px',
                      'height': _ctx.setSize.imgHeight,
                      'top':'-' + (parseInt(_ctx.setSize.imgHeight) + _ctx.vSpace) + 'px', 'background-size': _ctx.setSize.imgWidth + ' ' + _ctx.setSize.imgHeight,
            })
              }, [
                _createElementVNode("img", {
                  src: _ctx.blockBackImgBase,
                  alt: "",
                  style: {"width":"100%","height":"100%","display":"block"}
                }, null, 8, _hoisted_7)
              ], 4))
            : _createCommentVNode("", true)
        ], 36)
      ], 4)
    ], 4)
  ]))
}